<div class="referidos">
  <header class="ref-header">
    <h1>{{ activo ? 'Invita y gana' : 'Tu usuario de Aguacate' }}</h1>
    <p *ngIf="activo && fraseReferidor">{{ fraseReferidor }}</p>
    <p *ngIf="activo && fraseReferidor && fraseCondiciones">{{ fraseCondiciones }}</p>
    <p *ngIf="activo && !fraseReferidor">Comparte tu usuario para invitar a tus conocidos a Aguacate.</p>
    <p *ngIf="!activo">Es tu identidad en Aguacate. Créalo ahora y quedará listo para cuando
       comiencen las promociones de referidos.</p>
  </header>

  <div class="ref-cargando" *ngIf="cargando">Cargando…</div>

  <ng-container *ngIf="!cargando">
    <!-- Crear el usuario Aguacate. Desaparece una vez creado. -->
    <section class="ref-card ref-crear" *ngIf="!llave">
      <h2>Crea tu usuario de Aguacate</h2>
      <p class="ref-sub" *ngIf="activo">
        Es tu identidad para invitar. Entre 8 y 10 caracteres, sólo letras y números, sin tildes ni ñ.
      </p>
      <p class="ref-sub" *ngIf="!activo">
        Créalo ahora y lo tendrás listo: lo necesitarás para las promociones de
        referidos cuando estén disponibles. Entre 8 y 10 caracteres, sólo letras y números,
        sin tildes ni ñ.
      </p>

      <div class="ref-input-row">
        <span class="ref-arroba">&#64;</span>
        <input
          type="text"
          [(ngModel)]="llaveBorrador"
          (input)="onLlaveInput()"
          maxlength="10"
          autocomplete="off"
          placeholder="TUUSUARIO1"
          [class.error]="llaveEstado === 'tomada'"
        />
      </div>

      <p class="ref-estado libre" *ngIf="llaveEstado === 'libre'">
        &#64;{{ llaveBorrador }} está disponible
      </p>
      <p class="ref-estado" *ngIf="llaveEstado === 'verificando'">Verificando…</p>
      <p class="ref-estado error" *ngIf="llaveMensaje">{{ llaveMensaje }}</p>

      <button
        class="ref-btn"
        [disabled]="llaveEstado !== 'libre' || creando"
        (click)="crearLlave()"
      >
        {{ creando ? 'Creando…' : 'Crear mi usuario' }}
      </button>
    </section>

    <ng-container *ngIf="llave">
      <!-- El usuario. Siempre visible: ya es suyo. -->
      <section class="ref-card">
        <h2>{{ activo ? 'Tu usuario y tu link' : 'Tu usuario' }}</h2>
        <div class="ref-llave">&#64;{{ llave }}</div>

        <!-- El link, sólo con el programa encendido. Un vínculo creado
             mientras está apagado congela su bono en 0 y no paga nunca, así
             que compartirlo ahora sería quemarle los invitados al cliente. -->
        <ng-container *ngIf="activo">
          <div class="ref-link">{{ link }}</div>
          <div class="ref-acciones">
            <button class="ref-btn" (click)="compartir()">Compartir</button>
            <button class="ref-btn ghost" (click)="copiarLink()">Copiar link</button>
          </div>
        </ng-container>

        <p class="ref-sub" *ngIf="!activo">
          Tu usuario ya está reservado. Cuando comiencen las promociones de referidos podrás
          compartir tu link desde aquí.
        </p>
      </section>

      <!-- Totales -->
      <section class="ref-card" *ngIf="resumen">
        <h2>Tus bonos</h2>
        <div class="ref-nums">
          <div class="ref-num">
            <span class="n">{{ totalesTexto('liberado') }}</span>
            <span class="l">ganados</span>
          </div>
          <div class="ref-num">
            <span class="n">{{ totalesTexto('pendiente') }}</span>
            <span class="l">esperando</span>
          </div>
          <div class="ref-num">
            <span class="n">{{ resumen.invitadosQueFondearon }}<small>/{{ resumen.invitados }}</small></span>
            <span class="l">invitados que cargaron</span>
          </div>
        </div>

        <!-- Bono propio: sólo si a este usuario lo invitó alguien -->
        <div class="ref-mibono" *ngIf="resumen.miBono">
          <strong>
            Tu bono de bienvenida: {{ resumen.miBono.montoUsdt }} {{ resumen.miBono.moneda }}
          </strong>
          <span *ngIf="resumen.miBono.falta">{{ resumen.miBono.falta }}</span>
          <span class="ok" *ngIf="!resumen.miBono.falta">Ya está en tu wallet.</span>
        </div>
      </section>

      <!-- Invitados -->
      <section class="ref-card">
        <h2>Tus invitados</h2>

        <p class="ref-vacio" *ngIf="!referidos.length">
          <span *ngIf="activo">Todavía no has invitado a nadie. Comparte tu link para empezar.</span>
          <span *ngIf="!activo">Todavía no has invitado a nadie.</span>
        </p>

        <div class="ref-tabla" *ngIf="referidos.length">
          <div class="ref-fila" *ngFor="let r of referidos">
            <div class="ref-quien">
              <strong>{{ r.nombre }}</strong>
              <span>{{ r.registradoAt | date: 'dd/MM/yyyy' }}</span>
            </div>
            <!--
              El motivo lo escribe el backend en cada corrida del job, y por eso
              se muestra tal cual.

              Antes esta pantalla decía «ya cargó · tu bono se está liberando» a
              cualquiera que tuviera un invitado con fondeo, incluso cuando el
              bono no iba a salir nunca: al referidor le podía faltar actividad,
              el vínculo podía haberse quedado sin campaña o el bono podía estar
              vencido. Era una promesa que el módulo no iba a cumplir, y cada una
              de esas es un ticket.
            -->
            <div class="ref-estado-fila">
              <span class="pill ok" *ngIf="r.bonoEstado === 'LIBERADO'">
                Cobraste {{ r.montoUsdt | number: '1.0-2' }} {{ r.moneda }}
              </span>
              <span class="pill bad" *ngIf="r.bonoEstado === 'VENCIDO' || r.bonoEstado === 'ANULADO'">
                {{ r.falta || 'Este bono ya no se acredita' }}
              </span>
              <span
                class="pill"
                [class.wait]="r.fondeo"
                *ngIf="r.bonoEstado !== 'LIBERADO' && r.bonoEstado !== 'VENCIDO' && r.bonoEstado !== 'ANULADO'"
              >
                {{ r.falta || 'En revisión' }}
              </span>
            </div>
          </div>
        </div>

        <div class="ref-paginado" *ngIf="total > limit">
          <button class="ref-btn ghost" [disabled]="page <= 1" (click)="cargarReferidos(page - 1)">
            Anterior
          </button>
          <span>{{ page }} de {{ totalPaginas }}</span>
          <button
            class="ref-btn ghost"
            [disabled]="page >= totalPaginas"
            (click)="cargarReferidos(page + 1)"
          >
            Siguiente
          </button>
        </div>
      </section>

    </ng-container>
  </ng-container>
</div>
